export default "__VITE_ASSET__Dfp4ujs1__"